@use "sass:math";
@use "sass:map";
@use "sass:list";
@use "../../../../globals/settings";
@use "../../../../globals/bcp";
@use "../../../../globals/bcp-2022/objects/links";
@use "../../../../globals/bcp-2022/objects/lists";
@use "../../../../globals/forwards/typography";
@use "../../../../globals/bcp-2022/common/box-shadow";
@use "../../../../globals/libs/hy.core.css/objects/button-starter" as buttons;
@use "../../../../globals/libs/hy.core.css/layout/page-row";

$mobile-width: 100vw;
$shadow-height: 10px;
$bg: bcp.colorVar("bg");
$layer-column-gap: bcp.nSpace(4);
$page-padding: list.nth(map.get(settings.$page-padding, "all"), 1);
$transition-mobile: all 0.5s ease 0s;
$layer-padding-bottom-desktop: bcp.nSpace(8);
$menu-icon-bg: transparent;
$menu-icon-color: bcp.colorVar("text");
$menu-icon-color-hover: bcp.colorVar("link-text");
$menu-icon-color-active: bcp.colorVar("link-hover");

@mixin layer-shadow {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  background: $bg;

  @include box-shadow.variant();
}

@mixin layer-shadow-blocker {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: $shadow-height;
  background: $bg;
}

$self: ".f-nav";

:host {
  // ------------------- FIX CUSTOM TAGS ------------------------------------------------------------------------------
  display: block;
}

// ------------------- COMMON ---------------------------------------------------------------------------------------
#{$self}__lvl-1 {
  @include lists.reset;
  display: flex;

  &__link {
    @include buttons.button-reset;
    display: inline-block;
    text-decoration: none;
    cursor: pointer;

    &:hover,
    &.is-active {
      color: links.$link-color;
    }
  }
}

#{$self}__lvl-2,
#{$self}__lvl-3 {
  @include lists.reset;
  display: flex;
  flex-direction: column;

  &__link {
    @include buttons.button-reset;
    display: inline-block;
    text-decoration: none;
    cursor: pointer;

    &:hover,
    &.is-active {
      color: links.$link-color;
    }

    &.has-sub {
      position: relative;

      @include links.with-icon;

      @include links.primary;
    }

    &.is-external {
      @include links.with-icon;
    }
  }
}

#{$self}__lvl-3,
#{$self}__lvl-4 {
  @include lists.reset;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  &__link {
    @include buttons.button-reset;
    display: inline-block;
    text-decoration: none;
    cursor: pointer;

    @include typography.text-m();

    &:hover {
      color: links.$link-color;
    }

    &.is-external {
      @include links.with-icon;
    }
  }
}

// ------------------- DESKTOP --------------------------------------------------------------------------------------
@include bcp.respond-gte(tabletl) {
  #{$self}__back {
    display: none;
  }

  // ------------------- DESKTOP - LVL 1 ----------------------------------------------------------------------------

  #{$self}__lvl-1 {
    gap: bcp.nSpace(4, settings.$rel-unit);

    &__link {
      @include typography.text-l();

      &.is-active ~ #{$self}__layer {
        display: block;
      }
    }
  }

  // ------------------- DESKTOP - LAYER ----------------------------------------------------------------------------

  #{$self}__layer {
    display: none;
    box-sizing: border-box;
    //overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    background: $bg;
    padding-top: bcp.nSpace(6);
    padding-bottom: calc(#{bcp.nSpace(5)} + #{$shadow-height});

    @include bcp.z-index("navigation", 1);

    &::before {
      @include layer-shadow;
    }

    &::after {
      @include layer-shadow-blocker;
    }

    .l-page-row {
      @include page-row.page-row;
    }
  }
  // ------------------- DESKTOP - LVL 2 ----------------------------------------------------------------------------

  #{$self}__lvl-2 {
    width: 33%;
    position: relative;
    gap: bcp.nSpace(3, settings.$rel-unit);

    &__item {
      &--special {
        padding-top: bcp.nSpace(4, settings.$rel-unit);
      }
    }

    &__link {
      @include typography.text-xl();

      &.has-sub {
        padding-right: 1rem;

        @include links.primary-icon {
          position: absolute;
          right: 0;
          transform: translateY(85%) rotate(45deg);
        }
      }

      &.is-external {
        @include bcp.set-icon-size("l");
      }

      &.is-active ~ #{$self}__inner-layer {
        display: block;
      }
    }
  }

  // ------------------- DESKTOP - LVL 3 ----------------------------------------------------------------------------

  #{$self}__inner-layer {
    display: none;

    position: absolute;
    left: calc(100% + #{$layer-column-gap});
    top: 0;
    bottom: 0;
    width: calc(200% - #{math.div($layer-column-gap, 2)});

    &__heading {
      margin: 0 0 bcp.nSpace(2, settings.$rel-unit);
      font-weight: bcp.$font-weight-bold;
    }
  }

  #{$self}__lvl-3 {
    row-gap: bcp.nSpace(4, settings.$rel-unit);
    column-gap: $layer-column-gap;
    height: calc(100% - #{bcp.nSpace(8)});

    &__item {
      width: calc(50% - #{math.div($layer-column-gap, 2)});
    }

    &__link {
      &.has-sub {
        padding-right: 1rem;

        @include links.primary-icon {
          position: absolute;
          right: 0;
          transform: translateY(85%) rotate(45deg);
        }
      }

      &.is-external {
        @include bcp.set-icon-size("l");
      }

      &.is-active ~ #{$self}__inner-layer-lvl-4 {
        display: block;
      }
    }
  }

  // ------------------- DESKTOP - LVL 4 ----------------------------------------------------------------------------

  #{$self}__inner-layer-lvl-4 {
    display: none;

    position: absolute;
    left: calc(50% + #{$layer-column-gap});
    top: 0;
    bottom: 0;
    width: calc(50% - #{math.div($layer-column-gap, 2)});

    &__heading {
      margin: 0 0 bcp.nSpace(2, settings.$rel-unit);
      font-weight: bcp.$font-weight-bold;
    }
  }

  #{$self}__lvl-4 {
    row-gap: bcp.nSpace(4, settings.$rel-unit);
    column-gap: $layer-column-gap;
    height: calc(100% - #{bcp.nSpace(8)});
  }

  // ------------------- LANG SELECTOR ------------------------------------------------------------------------------

  #{$self}__lang-selector-wrapper {
    margin-top: bcp.nSpace(4);

    &--tablet {
      @include bcp.respond-gte(tabletl) {
        display: none;
      }
    }
  }
}

// ------------------- HELPERS OF SORT ------------------------------------------------------------------------------

.u-acc-hide {
  @include bcp.acc-hide();
}

// ------------------- MOBILE ---------------------------------------------------------------------------------------
@include bcp.respond-lte(tabletp) {
  // ------------------- LAYER / DRAWER -----------------------------------------------------------------------------
  .f-main-navigation {
    display: none;
    position: absolute;
    left: 0;
    right: 0;

    @include bcp.z-index("navigation", 1);

    &__track {
      position: relative;
      left: 0;
      transition: $transition-mobile;

      &.this-is-animation,
      &.show-menu__lvl-2 {
        left: $mobile-width * -1;
        transition: $transition-mobile;
      }

      &.show-menu__lvl-3 {
        left: $mobile-width * -2;
        transition: $transition-mobile;
      }

      &.show-menu__lvl-4 {
        left: $mobile-width * -3;
        transition: $transition-mobile;
      }
    }
  }

  // ------------------- TRIGGER BUTTON  ---------------------------------------------------------------
  f-navigation-trigger.is-active + .f-main-navigation {
    display: block;
  }

  #{$self}__layer {
    visibility: hidden;
  }

  #{$self}__lvl-1 {
    flex-direction: column;
    padding-top: bcp.nSpace(2, settings.$rel-unit);
    padding-bottom: $shadow-height;
    width: $mobile-width;
    background: $bg;

    &::before {
      @include layer-shadow;
    }

    &::after {
      @include layer-shadow-blocker;
    }

    &__link {
      @include typography.text-xl();
      padding: bcp.nSpace(2, settings.$rel-unit) $page-padding;

      &.has-sub {
        @include links.with-icon;
        @include links.primary;
        justify-content: space-between;
        width: 100%;
      }

      &.is-active ~ #{$self}__layer {
        visibility: visible;

        #{$self}__lvl-2 {
          visibility: visible;
          transition: visibility 0s ease 0s;
        }
      }
    }
  }

  #{$self}__lvl-2 {
    visibility: hidden;
    transition: visibility 0s ease 1.5s;
    box-sizing: border-box;
    position: absolute;
    left: $mobile-width;
    width: $mobile-width;
    top: 0;
    padding: 0 0 calc(#{bcp.nSpace(2)} + #{$shadow-height * 2});
    background: $bg;

    &::before {
      @include layer-shadow;
    }

    &::after {
      @include layer-shadow-blocker;
    }

    &__link {
      padding: bcp.nSpace(2, settings.$rel-unit) $page-padding;

      &.has-sub {
        justify-content: space-between;
        width: 100%;

        @include links.primary-icon {
          transform-origin: top right;
        }
      }

      &.is-active ~ #{$self}__inner-layer {
        visibility: visible;

        #{$self}__lvl-3 {
          visibility: visible;
          transition: visibility 0s ease 0s;
          display: flex;
        }
      }
    }
  }

  #{$self}__lvl-3 {
    visibility: hidden;
    transition: visibility 0s ease 1.5s;
    box-sizing: border-box;
    position: absolute;
    left: $mobile-width;
    width: $mobile-width;
    top: 0;
    padding: 0 0 calc(#{bcp.nSpace(2)} + #{$shadow-height * 2});
    background: $bg;

    &::before {
      @include layer-shadow;
    }

    &::after {
      @include layer-shadow-blocker;
    }

    &__link {
      padding: bcp.nSpace(2, settings.$rel-unit) $page-padding;

      &.has-sub {
        justify-content: space-between;
        width: 100%;

        @include links.primary-icon {
          transform-origin: top right;
        }
      }

      &.is-active ~ #{$self}__inner-layer-lvl-4 {
        visibility: visible;
        display: block;

        #{$self}__lvl-4 {
          visibility: visible;
          transition: visibility 0s ease 0s;
          display: flex;
        }
      }
    }
  }

  #{$self}__inner-layer {
    visibility: hidden;

    &__heading {
      font-weight: bcp.$font-weight-bold;
    }
  }
  #{$self}__inner-layer-lvl-4 {
    visibility: hidden;
    display: none;
  }

  #{$self}__back-btn {
    @include buttons.button-reset;
    padding: bcp.nSpace(2) $page-padding 0;
    cursor: pointer;
  }

  #{$self}__lvl-3,
  #{$self}__lvl-4 {
    visibility: hidden;
    transition: visibility 0s ease 1.5s;
    display: flex;
    position: absolute;
    left: $mobile-width;
    width: $mobile-width;
    top: 0;
    padding: 0 0 calc(1rem + #{$shadow-height * 2});
    background: $bg;
    box-sizing: border-box;

    &__link {
      padding: bcp.nSpace(2, settings.$rel-unit) $page-padding;
    }

    &::before {
      @include layer-shadow;
    }

    &::after {
      @include layer-shadow-blocker;
    }
  }

  #{$self}__lang-selector-wrapper {
    padding: bcp.nSpace(2.5) $page-padding
      calc(#{bcp.nSpace(2)} + #{$shadow-height * 2});
    background: $bg;

    &--desktop {
      display: none;
    }
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
/* stylelint-disable no-duplicate-selectors */
@include bcp.theme("buderus") {
  $logo-width: 162px;
  $logo-spacing: calc($logo-width + $page-padding + $page-padding);
  // ------------------- DESKTOP --------------------------------------------------------------------------------------
  @include bcp.respond-gte(tabletl) {
    // ------------------- DESKTOP - LVL 1 ----------------------------------------------------------------------------
    // ------------------- DESKTOP - LAYER ----------------------------------------------------------------------------
    #{$self}__layer {
      background: transparent;
      padding-top: 0;
      padding-bottom: 0;
      padding-left: $logo-width;

      &::before {
        display: none;
      }

      &::after {
        display: none;
      }

      .l-page-row {
        background: $bg;
        max-width: calc(1152px - $logo-spacing);
        padding-top: bcp.nSpace(6);
        padding-bottom: #{bcp.nSpace(5)};
      }
    }
  }
}
